import Box from "../../lib/appfuse-react/component/Box";
import Button from "../../lib/appfuse-react/component/Button";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import {Typography} from "@material-ui/core";

function PromptTest() {
    const prompt = usePrompt();
    const SHORT_MESSAGE = "資料上傳成功。";
    const LONG_MESSAGE = "在 iOS 13 的 Safari 中，下載的檔案預設會儲存在「檔案」應用程式中。";
    const VERY_LONG_MESSAGE = "在 iOS 13 的 Safari 中，下載的檔案預設會儲存在「檔案」應用程式中。這是一個內建的應用程式，可以用來管理您的檔案、資料夾和下載的內容。";
    const LINEBREAK_MESSAGE = "有下列錯誤：\n-錯誤一\n-錯誤二";
    const LONG_TITLE = "在 iOS 13 的 Safari 中，下載的檔案預設會儲存在「檔案」應用程式中。";

    const handleInfoWithShortMessage = () => {
        prompt.info(SHORT_MESSAGE);
    }
    const handleInfoWithLongMessage = () => {
        prompt.info(LONG_MESSAGE, {actions: ['YES', 'NO']});
    }

    const handleInfoWithVeryLongMessage = () => {
        prompt.info(VERY_LONG_MESSAGE, {actions: ['YES', 'NO']});
    }

    const handleInfoWithLinebreakMessage = () => {
        prompt.info(LINEBREAK_MESSAGE);
    }
    const handleInfoWithLongSubjectAndMessage = () => {
        prompt.info(LONG_MESSAGE,
            {title: LONG_TITLE});
    }


    const handleConfirmWithShortMessage = () => {
        prompt.confirm(SHORT_MESSAGE);
    }
    const handleConfirmWithLongMessage = () => {
        prompt.confirm(LONG_MESSAGE, {actions: ['YES', 'NO']});
    }

    const handleConfirmWithVeryLongMessage = () => {
        prompt.confirm(VERY_LONG_MESSAGE, {actions: ['YES', 'NO']});
    }

    const handleConfirmWithLinebreakMessage = () => {
        prompt.confirm(LINEBREAK_MESSAGE);
    }
    const handleConfirmWithLongSubjectAndMessage = () => {
        prompt.confirm(LONG_MESSAGE,
            {title: LONG_TITLE});
    }





    return (
        <Box display="flex" flexWrap="wrap" padding={2} gap={2}>
            <Button variant="outlined" text="Info: Short Message" noWrap onClick={handleInfoWithShortMessage} />
            <Button variant="outlined" text="Info: Long Message" noWrap onClick={handleInfoWithLongMessage} />
            <Button variant="outlined" text="Info: Very Long Message" noWrap onClick={handleInfoWithVeryLongMessage} />
            <Button variant="outlined" text="Info: Linebreak Message" noWrap onClick={handleInfoWithLinebreakMessage} />
            <Button variant="outlined" text="Info: Long Title & Message" noWrap onClick={handleInfoWithLongSubjectAndMessage} />
            <Button variant="outlined" text="Confirm: Short Message" noWrap onClick={handleConfirmWithShortMessage} />
            <Button variant="outlined" text="Confirm: Long Message" noWrap onClick={handleConfirmWithLongMessage} />
            <Button variant="outlined" text="Confirm: Very Long Message" noWrap onClick={handleConfirmWithVeryLongMessage} />
            <Button variant="outlined" text="Confirm: Linebreak Message" noWrap onClick={handleConfirmWithLinebreakMessage} />
            <Button variant="outlined" text="Confirm: Long Title & Message" noWrap onClick={handleConfirmWithLongSubjectAndMessage} />
        </Box>
    )
}

export default PromptTest;